module.exports = __webpack_public_path__ + "media/images/close-3338e53b.svg";